/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import moment from 'moment';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { setLoading } from '../Store/actions';
import {  getRequiredColumnOnExportPDF } from './TableHead';

pdfMake.vfs = pdfFonts.pdfMake.vfs;
const drugActivityValue = {
  R: ['URAC', 'URCA', 'URAL'],
  W: ['WOFF', 'DBAL', 'FRGV'],
  I: ['IOAR', 'IDBL'],
  X: ['ICLC', 'IDBU'],
  U: ['UACD', 'UACM', 'UAAR', 'UCCN', 'UOCR', 'UOMR'],
  T: ['DBUP'],
};
const contentFont = 10;
const pageMargins = [42, 80, 28.8, 25.92];
const styles = {
  header: {
    fontSize: 18,
    bold: true,
    margin: [0, 0, 0, 10],
  },
  subheader: {
    fontSize: 16,
    bold: true,
    margin: [0, 10, 0, 5],
  },
  tableExample: {
    margin: [0, 5, 0, 15],
  },
  tableHeader: {
    bold: true,
    fontSize: 13,
    color: 'black',
  },
};

const amountFormatter = (value) => {
  if (value < 0) {
    return `($ ${value
      ?.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
      })
      .substring(2)})`;
  }
  return value?.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });
};

const numberFormatter = (value) => {
  if (value < 0) {
    return `(${parseFloat(value)?.toLocaleString('en-US')?.substring(1)})`;
  }
  return value?.toLocaleString('en-US');
};
const getHeader = (currentPage, pageCount, data, options) => {
  const { prinDate, requestedBy, reportName } = data;

  const { pageSize, info } = options;
  const {
    firstInfo = '',
    secondInfo = '',
    thirdInfo = '',
    fourthInfo = '',
    fifthInfo = '',
  } = info;

  let widths = [255, 255, 255];
  if (pageSize && pageSize.width) {
    const w = (pageSize.width - 80) / 3;
    widths = [w, w, w];
  }
  const header = {
    alignment: 'center',
    fontSize: 10,
    margin: [38.8, 20, 28.8, 25.92],
    style: 'tableExample',
    table: {
      widths: widths,
      body: [
        [
          {
            text: [{ text: 'Requested By: ', bold: true }, requestedBy],
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'left',
          },
          {
            text: reportName,
            fontSize: 12,
            bold: true,
            fontFamily: 'arial',
            alignment: 'center',
          },
          {
            text: [{ text: 'Date Printed: ', bold: true }, prinDate],
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'right',
          },
        ],
        [
          {
            text: firstInfo,
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'left',
          },
          {
            text: thirdInfo,
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'center',
            bold: true,
          },
          {
            text: `Page ${currentPage} of ${pageCount}`,
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'right',
          },
        ],
        [
          {
            text: secondInfo,
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'left',
          },
          {
            text: fourthInfo,
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'center',
            bold: true,
          },
          {
            text: fifthInfo,
            fontSize: 10,
            fontFamily: 'arial',
            alignment: 'right',
          },
        ],
      ],
    },
    layout: 'noBorders',
  };
  return header;
};
const RedColor='#a81f00'

const getTableBodyData = (data, cols, key) => {
  const dataToReturn = [];
  const totaRecordCount = 0;
  const columns = [];
  for (let i = 0; i < cols.length; i += 1) {
    columns.push({
      text: cols[i].headerName,
      fontSize: contentFont,
      border: [true, true, true, true],
      bold: true,
      alignment: cols[i].alignment || 'left',
    });
  }
  dataToReturn.push(columns);
  let totalRowObj = drugActivityValue[key].reduce(
    (acc, curr) => ((acc[curr] = 0), acc),
    { total: 0 }
  );
  const colToSum = ['total', ...drugActivityValue[key]];
  totalRowObj = {
    ...totalRowObj,
    targetQtr: 'Total',
    mfgName: '',
    adjustTypeCd: '',
  };
  for (let i = 0; i < data.length; i += 1) {
    const tempCols = [];

    for (let j = 0; j < cols.length; j += 1) {
      let text = data[i][cols[j].field];
      const TotalBold = data[i].targetQtr === 'Total' || false;
      const boolValue = data[i]?.bold || false;
      if (cols[j].isAmount) {
        text = amountFormatter(data[i][cols[j].field] || 0);
      } else if (typeof text === 'number') {
        text = numberFormatter(data[i][cols[j].field] || 0);
      }
      tempCols.push({
        text,
        fontSize: boolValue || TotalBold ? contentFont : contentFont - 1,
        border: [true, true, true, true],
        bold: boolValue || TotalBold,
        alignment: cols[j].alignment || 'left',
        color:
          typeof data[i][cols[j].field] === 'number' &&
          data[i][cols[j].field] < 0
            ? RedColor
            : 'black',
      });
    }
    dataToReturn.push(tempCols);
    for (let k = 0; k < colToSum.length; k += 1) {
      if (data[i].targetQtr !== 'Total') {
        totalRowObj[colToSum[k]] += data[i][colToSum[k]] || 0;
      }
    }
  }
  const tempCols = [];
  for (let j = 0; j < cols.length; j += 1) {
    let text = totalRowObj[cols[j].field];
    if (cols[j].isAmount) {
      text = amountFormatter(totalRowObj[cols[j].field]);
    } else if (typeof text === 'number') {
      text = numberFormatter(totalRowObj[cols[j].field]);
    }
    tempCols.push({
      text,
      fontSize: contentFont,
      border: [true, true, true, true],
      bold: true,
      alignment: cols[j].alignment || 'left',
      color:
        typeof totalRowObj[cols[j].field] === 'number' &&
        totalRowObj[cols[j].field] < 0
          ? RedColor
          : 'black',
    });
  }
  dataToReturn.push(tempCols);
  return dataToReturn;
};
const getTableBody = (data, options, columnApi) => {
  const { adjustmentSelected } = options;
  const body = [];
  const dataKeys = Object.keys(data);
  dataKeys.sort();

  for (let i = 0; i < dataKeys.length; i += 1) {
    const cols = getRequiredColumnOnExportPDF(dataKeys[i], true,columnApi);
    const widths = cols.map((item, index) =>
      dataKeys[i] === 'U' && index === 1 ? 125 : index === 1 ? 300 : '*'
    );

    const matchedAdjutment = adjustmentSelected.find(
      (item) => item.codeValue == dataKeys[i]
    );

    body.push({
      text: [
        { text: 'Adjustment Type: ', bold: true, fontSize: contentFont },
        {
          text: `${dataKeys[i]} - ${matchedAdjutment?.longDescription}`,
          fontSize: contentFont,
        },
      ],
    });
    body.push({
      style: 'tableExample',
      table: {
        widths: ['*'],
        body: [
          [
            {
              style: 'tableExample',
              table: {
                headerRows: 1,
                widths: widths,
                body: getTableBodyData(data[dataKeys[i]], cols, dataKeys[i]),
              },
            },
          ],
        ],
      },
      layout: 'noBorders',
    });
    if (i < dataKeys.length - 1)
      body.push({
        text: '',
        fontSize: 14,
        bold: true,
        pageBreak: 'before',
        margin: [0, 0, 0, 8],
      });
  }
  return body;
};

/**
 * Download as PDF with all Data.
 * @param {object} headerData - conatisn header info of PDF.
 * @param {object} bodyData - constains Body data for PDF.
 * @param {object} options - constains additional dara for PDF.
 */
const getPdfData = (bodyData, headerData, options, columnApi) => {
  const { pageSize } = options;
  const content = getTableBody(bodyData, options, columnApi);
  const currentYear = new Date().getFullYear();
  let docDefinition = {
    header: (currentPage, pageCount) => {
      return getHeader(currentPage, pageCount, headerData, options);
    },
    footer: () => {
        const footers = [];
        footers.push({
          text:`${currentYear} Conduent Business Services, LLC. All rights reserved. Conduent and Conduent Agile Star are trademarks of Conduent Business Services, LLC in the United States and/or other countries.`,
          fontSize: 8,
          color: '#636363',
          fontFamily: 'Arial',
          alignment: 'center',
        });

      return footers;
    },
    content,
    pageMargins,
    styles,
    pageOrientation: 'landscape',
  };

  if (pageSize && pageSize?.width && pageSize.height) {
    docDefinition = {
      ...docDefinition,
      pageSize: {
        width: pageSize.width,
        height: pageSize.height,
      },
    };
  }
  return docDefinition;
};

/**
 * Download as PDF with all Data.
 * @param {object} data - header info of PDF.
 * @param {object} userDefaultValues - use info containg object
 */
const getHeaderData = (UserDefaultsValues, options, logInUser) => {
  const { reportName } = options;
  return {
    prinDate: moment(new Date()).format('MM/DD/YYYY'),
    requestedBy:
      UserDefaultsValues && UserDefaultsValues.userId
        ? UserDefaultsValues.userId
        : logInUser,
    reportName,
  };
};

/**
 * Download as PDF with all Data.
 * @param {object} header - header info of PDF.
 * @param {object} bodyData - All the data for the PDF.
 * @param {object} userDefaultValues
 */
export const exportAllPDF = (
  bodyData,
  userDefaultValues,
  options = {},
  dispatch,
  logInUser,
  columnApi
) => {
  const headerData = getHeaderData(userDefaultValues, options, logInUser);

  const pdfData = getPdfData(bodyData, headerData, options, columnApi);
  pdfMake
    .createPdf(pdfData)
    .download(
      `${options?.fileName || options?.reportName || 'data'}.pdf`,
      () => {
        dispatch(setLoading(false));
      }
    );
};
